import { render, staticRenderFns } from "./edit-problem-form.vue.js?vue&type=template&id=149a3135!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./edit-problem-form.vue?vue&type=template&id=149a3135"
import script from "./edit-problem-form.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./edit-problem-form.vue?vue&type=script&lang=js"
export * from "./edit-problem-form.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./edit-problem-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports